/**
 * Functions helpers to manipulate dates and time 
 * from epoch to date and vice versa
 */

export default {
    methods: {
      getDateFromEpoch(epoch) {
        return new Date(epoch);
      },
      getEpochFromDate(date) {
        return new Date(date).getTime();
      },
      getEpochFromNow() {
        return new Date().getTime();
      },
      getReadableFormat(date) {
        if(String(date).length < 13) { date = date * 1000} //-- ! Dirty fix due to hardcoded values generated !
        const Y = new Date(date).getFullYear();
        let M = new Date(date).getMonth() + 1;
        M = M > 9 ? M : `0${M}`;
        let D = new Date(date).getDate();
        D = D > 9 ? D : `0${D}`;
        let h = new Date(date).getHours();
        h = h > 9 ? h : `0${h}`;
        let m = new Date(date).getMinutes();
        m = m > 9 ? m : `0${m}`; 
        return `${D}/${M}/${Y} - ${h}:${m}`;
      },
      getElapsedTime(timeStart, timeEnd) {
        const duration = timeEnd - timeStart - 3600000;
        let elapsed = new Date(duration).toLocaleString('en-US');
        let days = Number(elapsed.split(',')[0].split('/')[0]) - 1;
        let time = elapsed.split(',')[1].trim().split(':');
        return days > 0 ? `${days} jour${days > 1 ? 's' : ''} et ${time[0] - 1}H${time[1]}` : `${time[0]}H${time[1]}`;
      },
      isRunningGlobalStat(coll) {
        let now = new Date().getTime();
        let stats = {
          finished: 0,
          running: 0,
          next: 0,
        }
        coll.forEach( elmt => {
          if(elmt.start !== undefined && elmt.end !== undefined) {
            if( now < elmt.start ) {
              stats.next ++;
            } else if (now > elmt.end) {
              stats.finished ++;
            } else {
              stats.running ++;
            }
          }
        })
        return stats;
      },
      isRunning(start, end) {
        let now = new Date().getTime();
        if( now < start ) {
            return 'A venir'
        } else if (now > end) {
            return 'Terminé'
        } else {
            return 'En cours'
        }
      },
      getStatus(start, end) {
        let now = new Date().getTime();
        if( now < start ) {
            return 'wait'
        } else if (now > end) {
            return 'finished'
        } else if (now > start && now < end){
            return 'running'
        } else {
          return 'unknow';
        }
      }
    }
  }
  